module.exports = {
    getImgNumber: function(start){
        var start = start ? start : '2021-05-12';//开始时间
        var s1 = new Date(start.replace(/-/g, "/"));
        var s2 = new Date();//当前时间
        var days = s2.getTime() - s1.getTime();//当前时间与定义的时间戳
        var time = parseInt(days / (1000 * 60 * 60 * 24));
        //当前时间与定义的时间戳天数
        var interval = parseInt(time/7);
        var num = interval%6;
        var logo_bg_url = '/public/images/uic_bg' + (num+1) + '.png';
        return logo_bg_url;
    },
    random: function(min, max) {
        var num = Math.floor(Math.random() * (max - min)) + min;
        var logo_bg_url = '/public/images/uic_bg' + (num) + '.png';
        return logo_bg_url;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/login/tabLogin/switchImg.js
// module id = 108
// module chunks = 0